<div class="loader">
    <mat-spinner></mat-spinner>
</div>